import React from 'react';
import PropTypes from 'prop-types';

// Components
import Tile from 'components/tile';

// Styles
import styles from './tileNav.scss';

/**
 * Creates a menu of tiles.
 * @param  {string} options.title Title of the menu.
 * @param  {object} options.items Members of the menu.
 * @return {object}               Component jsx.
 */
const TileNav = ({
  title,
  items,
}) => (
  <nav className={styles.tileNav}>
    <h2 className={styles.title}>
      {title}
    </h2>
    <ul className={styles.list}>
      {items.map(({
        destination,
        label,
        icon,
        visible = true,
      }) => (!visible ? null : (
        <li className={styles.listItem} key={label}>
          <Tile
            destination={destination}
            label={label}
            icon={icon}
          />
        </li>
      )))}
    </ul>
  </nav>
);

TileNav.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    destination: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })).isRequired,
};

export default TileNav;



// WEBPACK FOOTER //
// ./app/components/tileNav/index.js